export enum EColors {
  DARK = "#041321",
  DARK2 = "#4A4A4A",
  GREY1 = "#F6F9FF",
  GREY2 = "#EAF0F5",
  LIGHT = "#FAFCFE",
  WHITE = "#FFFFFF",
}

export enum EFonts {
  Medium = "CeraMedium",
  Bold = "CeraBold",
  Regular = "CeraRegular",
  Medium2 = "InterMedium",
  Bold2 = "InterBold",
}

export enum EVariables {
  Spacing = "-1.62px",
  Spacing2 = "-0.756px",
  Radius1 = "27px",
  Radius2 = "45px",
}

export const AnimTap = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
}
